<template>
    <div class="invoiceDetails" uk-height-viewport>
        <Header/>
        <div v-if="isLoading" class="spinner-overlay">
            <div class="spinner"></div>
        </div>
        <div :class="{ 'uk-invisible': isLoading }">
        <div uk-grid class="uk-margin uk-margin-remove-right">
            <div class="uk-width-auto">
                <legend class="uk-legend uk-margin-left uk-text-left margin_bottom_small uk-text-bold">Information</legend>
            </div>
        </div>

        <div class="uk-flex uk-flex-column uk-margin-medium-bottom right-aligned">
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Date
                <div class="uk-text-right">
                    {{ invoice.createdAt ? formatDate(invoice.createdAt.toDate()) : 'Date not available' }}
                </div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                N°
                <div class="uk-text-right">#{{ invoice.invoiceID }}</div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Identité
                <div class="uk-text-right">{{ invoice.firstName }} {{ invoice.lastName }}</div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Email
                <div class="uk-text-right">
                    <input class="uk-input input-large" type="email" v-model="invoice.email" @blur="updateEmail" placeholder="Email du client">
                </div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Téléphone
                <div class="uk-text-right">
                    <input class="uk-input input-large" type="tel" v-model="invoice.phoneNumber" @blur="updatePhoneNumber" placeholder="Téléphone du client">
                </div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Montant HT
                <div class="uk-text-right">{{ (invoice.amount / 1.2).toFixed(2) }}€</div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Montant TTC
                <div class="uk-text-right">{{ invoice.amount }}€</div>
            </div>
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Montant TVA
                <div class="uk-text-right">{{ (invoice.amount - invoice.amount / 1.2).toFixed(2) }}€</div>
            </div>
            <div class="uk-grid-small uk-text-right" uk-grid>
                <div class="uk-form-controls uk-width-1-1 margin_bottom_element">
                    <label style="text-align: left; display: block;" for="remuneration">Rétribution :</label>
                    <input v-model="invoice.remuneration" class="uk-input" id="remuneration" type="text" placeholder="Montant HT de la rétribution de l’expert">
                </div>
                <div class="uk-flex uk-width-1-1 margin_bottom_element">
                    <div class="uk-width-4-5@s uk-margin">
                        <label style="text-align: left; display: block;" for="expert">Expert :</label>
                        <select class="uk-select" name="expert" v-model="expert">
                            <option value="">Sélectionner un expert</option>
                            <option v-for="exp in experts" :key="exp.uid" :value="exp.uid">
                                {{ exp.lastName }} {{ exp.firstName }}
                            </option>
                        </select>
                    </div>
                    <div class="uk-width-1-5@s">
                        <button uk-toggle="target: #modal-new-expert" class="uk-button rounded-btn uk-button-primary" style="margin-top: 24px;">
                            <span uk-icon="plus-circle"></span>
                            Ajouter un expert
                        </button>
                    </div>
                </div>
                <div class="uk-width-1-1 margin_bottom_element">
                    <label style="text-align: left; display: block;" for="typeRemuneration">Type de règlement :</label>
                    <div uk-form-custom="target: > * > span:first-child" style="width: 100%;">
                        <select v-model="invoice.typeRemuneration" aria-label="Custom controls" id="typeRemuneration">
                            <option value="">Type de règlement</option>
                            <option v-for="(label, key) in paymentTypes" :key="key" :value="key">{{ label }}</option>
                        </select>
                        <button class="uk-button uk-button-default" type="button" tabindex="-1" style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <span>Type de règlement</span>
                            <span uk-icon="icon: chevron-down"></span>
                        </button>
                    </div>
                </div>
                <div class="uk-width-1-2@s uk-margin margin_bottom_element">
                    <label style="text-align: left; display: block;" for="date">Date :</label>
                    <input class="uk-input" type="date" id="date" placeholder="Sélectionner une date" v-model="invoice.date">
                </div>
                <div class="uk-width-1-2@s uk-margin margin_bottom_large">
                    <label style="text-align: left; display: block;" for="time">Heure :</label>
                    <input class="uk-input" type="time" id="time" placeholder="Sélectionner une heure" v-model="invoice.hours">
                </div>
                <div class="uk-flex uk-width-1-1 margin_bottom_element">
                    <div class="uk-width-3-5@s">
                        <div class="uk-text-left uk-text-bold">
                            <span uk-icon="comments" style="margin-right: 8px;"></span>
                            Envoyer un SMS au client
                        </div>
                    </div>
                    <div class="uk-width-1-5@s">
                        <div class="uk-text-left uk-text-bold">
                            <span uk-icon="receiver" style="margin-right: 8px;"></span>
                            {{ invoice.phoneNumber }}
                        </div>
                    </div>
                    <div class="uk-width-1-5@s">
                        <button uk-toggle="target: #modal-new-sms" class="uk-button rounded-btn uk-button-primary" @click="smsRecipient = 2">
                            <span uk-icon="plus" style="margin-right: 8px;"></span>
                            Paramétrer un SMS
                        </button>
                    </div>
                </div>

                <div class="uk-flex uk-width-1-1 margin_bottom_large">
                    <div class="uk-width-1-5@s uk-margin margin_bottom_element">
                        <div class="uk-text-left uk-text-bold">
                            <span class="uk-badge red-badge">{{ messages.length }}</span>
                            Messages programmées :
                        </div>
                    </div>
                    <div class="uk-width-4-5@s">
                        <div class="uk-text-left uk-text-bold">
                        <span
                            v-for="(item, index) in messages"
                            @click="message = item"
                            :key="index"
                            uk-toggle="target: #modal-see-sms"
                            :class="item.status ===  MessageStatus.DELIVERED? 'label-tag-sent' : 'label-tag'">
                            <span v-if="item.status === MessageStatus.DELIVERED" uk-icon="check"></span>{{ formatDate(item.date) }}
                        </span>
                        </div>
                    </div>
                </div>

                <div class="uk-flex uk-width-1-1 margin_bottom_element">
                    <div class="uk-width-3-5@s">
                        <div class="uk-text-left uk-text-bold">
                            <span uk-icon="comments" style="margin-right: 8px;"></span>
                            Envoyer un SMS à l'expert
                        </div>
                    </div>
                    <div class="uk-width-1-5@s">
                        <div class="uk-text-left uk-text-bold">
                            <span uk-icon="receiver" style="margin-right: 8px;"></span>
                            {{ getExpertPhoneNumber() }}
                        </div>
                    </div>
                    <div class="uk-width-1-5@s">
                        <button uk-toggle="target: #modal-new-sms" class="uk-button rounded-btn uk-button-primary"  @click="smsRecipient = 1" :disabled="!expert">
                            <span uk-icon="plus" style="margin-right: 8px;"></span>
                            Paramétrer un SMS
                        </button>
                    </div>
                </div>
                <div class="uk-flex uk-width-1-1 margin_bottom_large">
                    <div class="uk-width-1-5@s uk-margin margin_bottom_element">
                        <div class="uk-text-left uk-text-bold">
                            <span class="uk-badge red-badge">{{ messagesExpert.length }}</span>
                            Messages programmées :
                        </div>
                    </div>
                    <div class="uk-width-4-5@s">
                        <div class="uk-text-left uk-text-bold">
                            <span
                                v-for="(item, index) in messagesExpert"
                                @click="message = item"
                                :key="index"
                                uk-toggle="target: #modal-see-sms"
                                :class="item.status ===  MessageStatus.DELIVERED? 'label-tag-sent' : 'label-tag'">
                                <span v-if="item.status === MessageStatus.DELIVERED" uk-icon="check"></span>{{ formatDate(item.date) }}
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-flex uk-flex-column uk-margin-medium-bottom right-aligned">
            <div class="uk-margin-left uk-text-left margin_bottom_small uk-text-bold">
                Documents générés
                <div class="uk-text-right">
                    <button uk-toggle="target: #modal-new-document" type="button" class="uk-button rounded-btn uk-button-primary">Générer</button>
                </div>
            </div>
            <hr class="uk-margin-remove-top">
            <div v-for="(doc, i) in documents" :key="i" class="uk-flex uk-flex-middle uk-flex-between uk-margin-small-bottom">
                <div class="uk-width-1-4 uk-text-left uk-text-bold">{{ doc.name }}</div>
                <div class="uk-width-1-6 uk-text-center">{{ formatDate(doc.createdAt) }}</div>
                <div class="uk-width-1-6 uk-text-center">{{ doc.status }}</div>
                <div class="uk-width-1-6 uk-text-center">
                    <span
                        class="uk-form-default"
                        style="cursor:pointer; color: #D52828;"
                        uk-icon="file-pdf"
                        uk-tooltip="title: Consulter; delay: 500"
                        @click="consult(doc.url)">
                    </span>
                    <span
                        v-show="doc.metadataStatus === DocumentStatus.TO_SIGN"
                        class="uk-form-default"
                        style="cursor:pointer;"
                        uk-icon="trash"
                        @click="deleteDocument(i)"
                        uk-tooltip="title: Supprimer; delay: 500">
                    </span>
                </div>
                <div class="uk-width-1-4">
                    <button
                        @click="sendDocumentToYousign(i)"
                        v-show="doc.metadataStatus === DocumentStatus.TO_SIGN"
                        class="uk-button rounded-btn uk-button-primary">
                        Envoyer vers YouSign
                    </button>
                    <button
                        @click="removeDocumentFromYousign(i)"
                        v-show="doc.metadataStatus === DocumentStatus.WAITING"
                        class="uk-button rounded-btn uk-button-danger">
                        Supprimer de YouSign
                    </button>
                    <button
                        @click="downloadPDF(doc.url)"
                        v-show="doc.metadataStatus === DocumentStatus.SIGNED"
                        class="uk-button rounded-btn uk-button-primary">
                        Télécharger le document signé
                    </button>
                </div>
            </div>
        </div>
            <div id="modal-new-document" uk-modal>
                <div class="uk-modal-dialog uk-modal-body">
                    <h2 class="uk-modal-title uk-text-center">Générer une facture</h2>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-select-target">Envoyer à l'expert ou au client ?</label>
                        <div class="uk-form-controls">
                            <select class="uk-select" id="form-select-target" v-model="typeUser" v-on:change="userChange">
                                <option>Expert</option>
                                <option>Client</option>
                            </select>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-select-templete">Templète de document facture</label>
                        <div class="uk-form-controls">
                            <select class="uk-select" id="form-select-templete" v-model="curentTemplate">
                                <option value="">Sélectionner un template</option>
                                <option v-for="(template, key) in filtredTemplates" :key="key" :value="key">
                                    {{ template.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="'' !== curentTemplate">
                        <div v-for="(field, key) in filtredTemplates[curentTemplate].fields" :key="key">
                            <div class="uk-margin" v-if="field.name !== 'signing'">
                                <label class="uk-form-label">{{ field.name }}</label>
                                <div class="uk-form-controls">
                                    <input class="uk-input" type="text" v-model="field.value" placeholder="Input">
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="uk-text-center" uk-margin>
                        <button class="uk-button rounded-btn uk-margin-small-right uk-modal-close">Annuler</button>
                        <button class="uk-button rounded-btn uk-button-primary" uk-toggle="target: #modal-recap" :disabled="curentTemplate === ''">Générer</button>
                    </p>
                </div>
            </div>
            <div id="modal-new-expert" uk-modal>
                <div class="uk-modal-dialog uk-modal-body">
                    <h2 class="uk-modal-title uk-text-center">Ajouter un expert</h2>
                    <form class="uk-form-stacked">
                        <div class="uk-margin">
                            <label class="uk-form-label" for="expert-lastname">Nom</label>
                            <div class="uk-form-controls">
                                <input
                                    id="expert-lastname"
                                    v-model="newExpert.lastName.value"
                                    :class="{ 'uk-form-danger': newExpert.lastName.hasError }"
                                    class="uk-input"
                                    placeholder="Nom"
                                    type="text">
                            </div>
                        </div>

                        <div class="uk-margin">
                            <label class="uk-form-label" for="expert-firstname">Prénom</label>
                            <div class="uk-form-controls">
                                <input
                                    id="expert-firstname"
                                    v-model="newExpert.firstName.value"
                                    :class="{ 'uk-form-danger': newExpert.firstName.hasError }"
                                    class="uk-input"
                                    placeholder="Prénom"
                                    type="text">
                            </div>
                        </div>

                        <div class="uk-margin">
                            <label class="uk-form-label" for="expert-email">E-mail</label>
                            <div class="uk-form-controls">
                                <input
                                    id="expert-email"
                                    v-model="newExpert.email.value"
                                    :class="{ 'uk-form-danger': newExpert.email.hasError }"
                                    class="uk-input"
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$"
                                    placeholder="E-mail"
                                    required
                                    type="email"
                                    @blur="isEmail">
                                <span v-if="newExpert.email.hasError"
                                      class="uk-text-danger">{{ newExpert.email.errorMessage }}</span>
                            </div>
                        </div>

                        <div class="uk-margin">
                            <label class="uk-form-label" for="expert-phone">Téléphone</label>
                            <div class="uk-form-controls">
                                <input
                                    id="expert-phone"
                                    v-model="newExpert.phoneNumber.value"
                                    :class="{ 'uk-form-danger': newExpert.phoneNumber.hasError }"
                                    class="uk-input"
                                    pattern="0.*[0-9]{9}$"
                                    placeholder="Téléphone"
                                    required
                                    type="tel"
                                    @blur="isPhoneNumber">
                                <span v-if="newExpert.phoneNumber.hasError"
                                      class="uk-text-danger">{{ newExpert.phoneNumber.errorMessage }}</span>
                            </div>
                        </div>

                        <div class="uk-margin">
                            <label class="uk-form-label" for="expert-postal">Code postal</label>
                            <div class="uk-form-controls">
                                <input
                                    id="expert-postal"
                                    v-model="newExpert.postalCode.value"
                                    :class="{ 'uk-form-danger': newExpert.postalCode.hasError }"
                                    class="uk-input"
                                    placeholder="Code postal"
                                    type="text">
                            </div>
                        </div>

                        <p class="uk-text-center" uk-margin>
                            <button class="uk-button rounded-btn uk-margin-small-right uk-modal-close" type="button">Annuler</button>
                            <button class="uk-button rounded-btn uk-button-primary" type="button" @click="create">Sauvegarder</button>
                        </p>
                    </form>
                </div>
            </div>
            <div id="modal-recap" uk-modal="stack: true">
                <div class="uk-modal-dialog uk-modal-body">
                    <h2 class="uk-modal-title uk-text-center">Aperçu du document</h2>
                    <div id="pdf-preview" style="width: 100%; height: 80vh; position: relative">
                        <div v-show="isPdfLoading" class="spinner-overlay">
                            <div class="spinner"></div>
                        </div>
                        <div ref="pdfContainer" style="width: 100%; height: 100%"></div>
                    </div>
                    <p class="uk-text-left margin_bottom_small">Envoyer le document au client : {{ this.invoice.firstName }} {{ this.invoice.lastName }} ({{ this.invoice.email}})</p>

                    <p class="uk-text-center" uk-margin>
                        <button class="uk-button rounded-btn uk-button-primary uk-margin-small-right" @click="downloadPDF">Télécharger</button>
                        <button class="uk-button rounded-btn uk-button-primary" @click="saveAndCloseAllModals">Envoyer vers YouSign</button>
                    </p>
                </div>
            </div>
            <div id="modal-new-sms" uk-modal @show="onSmsModalShow">
                <div class="uk-modal-dialog uk-modal-body">
                    <h2 class="uk-modal-title uk-text-center">Envoyer un SMS {{ smsRecipient === 1 ? 'à l\'expert' : 'au client' }}</h2>
                    <div class="uk-margin">
                        <label class="uk-form-label">Sélectionner un template de message</label>
                        <div class="uk-form-controls">
                            <select class="uk-select" v-model="selectedTemplate" @change="updateSmsMessage">
                                <option value="">Sélectionner un template</option>
                                <option v-for="(template) in filteredTemplatesSMS" :key="template.uid" :value="template.uid">
                                  {{template.name}}
                                </option>
                            </select>
                        </div>
                        <label class="uk-form-label">Contenu du SMS</label>
                        <div class="uk-form-controls">
                            <textarea v-model="newMessage.message" class="uk-textarea" rows="5" placeholder=""></textarea>
                        </div>
                        <div class="uk-margin">
                            <label class="uk-form-label">Date</label>
                            <div class="uk-form-controls">
                                <input v-model="newMessage.date" class="uk-input" type="date" placeholder="Date">
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label class="uk-form-label">Heure</label>
                            <div class="uk-form-controls">
                                <input v-model="newMessage.time" class="uk-input" type="time" placeholder="Heure">
                            </div>
                        </div>
                        <p v-show="null !== newMessage.date && null !== newMessage.time" class="uk-text-left margin_bottom_small">L'envoi du SMS est prévu le {{ newMessage.date }} à {{ newMessage.time }}</p>
                        <p class="uk-text-center" uk-margin>
                            <button class="uk-button rounded-btn uk-button-primary"
                                    @click="sendSms(smsRecipient === 1)"
                                    :disabled="null === newMessage.date || null === newMessage.time || '' === newMessage.message || new Date(newMessage.date + 'T' + newMessage.time) < new Date()">
                                    Valider
                            </button>
                        </p>
                    </div>
                </div>
            </div>
            <div id="modal-see-sms" uk-modal>
                <div class="uk-modal-dialog uk-modal-body" style="border-radius: 8px; padding: 20px;">
                    <div class="uk-flex uk-flex-between uk-flex-middle" style="margin-bottom: 20px; position: relative;">
                        <p class="uk-text-left" style="margin: 0;">Message programmé le {{ formatDate(message.date, true) }}</p>
                        <div  v-show="MessageStatus.DELIVERED === message.status" class="uk-flex uk-flex-middle" style="gap: 10px;">
                            <div class="uk-text-left uk-text-bold">
                        <span
                            class="uk-margin-small-right label-tag-sent">
                            <span uk-icon="check"></span>Envoyé
                        </span>
                            </div>

                            <button class="uk-modal-close-default" type="button" uk-close style="position: static;"></button>
                        </div>
                    </div>
                    <p class="uk-text-left margin_bottom_small">{{ message.message }}</p>
                    <div style="text-align: right; margin-top: 20px;">
                        <button
                            :disabled="message.status === MessageStatus.DELIVERED"
                            class="uk-button rounded-btn uk-button-danger"
                            @click="deleteSms(message.campaign_id)">
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import moment from "moment";
import UIkit from "uikit";
import firebase, {firestore} from "firebase";
import MessageStatus from "@/enums/message-status";
import DocumentStatus from "@/enums/document-status";

export default {
    name: "InvoicesDetails",
    computed: {
        MessageStatus() {
            return MessageStatus
        },
        DocumentStatus() {
            return DocumentStatus
        },
    },
    components: {
        Header
    },
    data() {
        return {
            isLoading: true,
            isPdfLoading: false,
            isInitialLoad: false,
            updateTimeout: null,
            smsTemplate: [],
            selectedTemplate: '',
            filteredTemplatesSMS: [],
            newMessage: {
                campaign_id: null,
                message: '',
                date: null,
                time: null,
            },
            message: {},
            messagesExpert: {},
            messages: {},
            invoice: {},
            smsRecipient:null,
            newExpert: {
                lastName: {value: ''},
                firstName: {value: ''},
                email: {value: '', hasError: false},
                phoneNumber: {value: '', hasError: false},
                postalCode: {value: ''},
                hasCompletedWebOnboarding: {value: false},
            },
            experts: [],
            expert: '',
            typeUser: 'Expert',
            templates: [],
            documents: [],
            filtredTemplates: [],
            curentTemplate: '',
            modalInstance: null,
            pdf: null,
            paymentTypes : {
                1: "Virement",
                2: "CB",
                3: "CB en 2X sans frais",
                4: "CB en 3X sans frais",
                5: "CB en 4X sans frais",
                6: "Chèque"
            }
        }
    },
    async mounted() {
        this.isInitialLoad = true;
        this.invoice = this.$route.params.invoice;

        const [expertsSnapshot, templatesSnapshot, smsTemplateSnapshot] = await Promise.all([
            firebase.firestore().collection("Users").where("isExpert", "==", true).get(),
            firebase.firestore().collection("Templates").get(),
            firebase.firestore().collection("TemplatesSMS").get()
        ]);

        this.experts = expertsSnapshot.empty ? [] : expertsSnapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
        this.templates = templatesSnapshot.empty ? [] : templatesSnapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
        this.smsTemplate = smsTemplateSnapshot.empty ? [] : smsTemplateSnapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }));

        this.userChange();
        if (this.experts.length !== 0 && this.invoice.expertUID !== undefined) {
            this.expert = this.experts.find(expert => expert.uid === this.invoice.expertUID)?.uid || '';
        }

        await Promise.all([this.getSms(), this.getSmsExpert()]);

        this.modalInstance = UIkit.modal('#modal-recap');
        this.modalInstance.$el.addEventListener('beforeshow', this.generatePDF);

        const documentsRef = firebase.storage().ref().child(`documents/${this.invoice.uid}`);
        const res = await documentsRef.listAll();

        const documentPromises = res.items.map(async (itemRef) => {
            const { uid, nameFile, status, metadataStatus, templateId, SRid, yousignId } = this.getInfoDocument(itemRef.name);
            const metadata = await itemRef.getMetadata();
            const url = await itemRef.getDownloadURL();
            const cacheBustedURL = `${url}?cache-buster=${new Date().getTime()}`;

            this.documents.push({
                uid,
                url: cacheBustedURL,
                name: nameFile,
                createdAt: metadata.timeCreated,
                status,
                metadataStatus,
                templateId,
                SRid,
                yousignId
            });
        });

        await Promise.all(documentPromises);

        this.isInitialLoad = false;
        this.isLoading = false;
    },
    methods: {
        saveAndCloseAllModals() {
            this.closeModal('modal-recap');
            this.closeModal('modal-new-document');
            this.sendDocumentToYousign(this.documents.length - 1);
        },
        closeModal(modalId) {
            UIkit.modal(`#${modalId}`).hide();
        },
        isEmail: function () {
            var regex = RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$");
            this.newExpert.email.value = this.newExpert.email.value.trim();
            this.newExpert.email.hasError = !regex.test(this.newExpert.email.value);
            if (this.newExpert.email.hasError) {
                this.newExpert.email.errorMessage =
                    "Votre adresse email n'est pas au bon format.";
            } else {
                this.newExpert.email.errorMessage = "";
            }
        },
        isPhoneNumber: function () {
            var regex = RegExp("0.*[0-9]{9}$");
            this.newExpert.phoneNumber.value = this.newExpert.phoneNumber.value.trim();
            this.newExpert.phoneNumber.hasError = !regex.test(this.newExpert.phoneNumber.value);
            if (this.newExpert.phoneNumber.hasError) {
                this.newExpert.phoneNumber.errorMessage =
                    "Doit commencer par 0 et comporter 10 chiffres.";
            } else {
                this.newExpert.phoneNumber.errorMessage = "";
            }
        },
        create: async function () {
            this.isLoading = true;
            if (this.newExpert.email.hasError || this.newExpert.phoneNumber.hasError) {
                this.isLoading = false;
                return;
            } else {
                const data = {
                    lastName: this.newExpert.lastName.value,
                    firstName: this.newExpert.firstName.value,
                    email: this.newExpert.email.value,
                    phoneNumber: this.newExpert.phoneNumber.value,
                    postalCode: this.newExpert.postalCode.value,
                    hasCompletedWebOnboarding: this.newExpert.hasCompletedWebOnboarding.value,
                    isExpert: true
                };
                const res = await firebase.firestore().collection("Users").add(data);
                if (res) {
                    const invoiceRef = firebase.firestore().collection("Invoices").doc(this.invoice.uid).set({ expertUID: res.id }, { merge: true });
                    if (invoiceRef) {
                        const newExpert = {
                            uid: res.id,
                            ...data
                        };
                        this.experts.push(newExpert);
                        this.expert = newExpert.uid;

                        this.displayMessage("Expert ajouté avec succès", "success");
                        this.closeModal('modal-new-expert');
                    } else {
                        await firestore().collection("Users").doc(res.id).delete();
                        this.displayMessage("Erreur lors de l'ajout de l'expert", "danger");
                    }
                } else {
                    this.displayMessage("Erreur lors de l'ajout de l'expert", "danger");
                }
                this.isLoading = false;
            }
        },
        displayMessage: function(message, type) {
            UIkit.notification(message, {
                pos: "top-right",
                status: type,
            });
        },
        async sendSms(expert=false) {
            this.isLoading = true;
            this.newMessage.time = this.newMessage.time + ":00";
            const phoneNumber = expert ? this.getExpertPhoneNumber() :this.invoice.phoneNumber;
            var url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/sendSms";
            url += `?phoneNumber=${phoneNumber}`;
            url += `&messageText=${this.newMessage.message}`;
            url += `&delayDate=${this.newMessage.date}`;
            url += `&delayTime=${this.newMessage.time}`;
            url += `&uidInvoice=${this.invoice.uid}`;

            var request = new XMLHttpRequest();

            return new Promise((resolve, reject) => {
                request.open("GET", url, true);
                request.onload = () => {
                    if (200 === request.status) {
                        var data = JSON.parse(request.responseText);
                        if(expert) {
                            this.messagesExpert.push({
                                campaign_id: parseInt(data.campaign_id),
                                message: this.newMessage.message,
                                date: this.newMessage.date + " " + this.newMessage.time,
                                status: MessageStatus.WAITING
                            });
                        } else {
                            this.messages.push({
                                campaign_id: parseInt(data.campaign_id),
                                message: this.newMessage.message,
                                date: this.newMessage.date + " " + this.newMessage.time,
                                status: MessageStatus.WAITING
                            });
                        }
                        this.closeModal('modal-new-sms');
                        this.displayMessage("Message programmé avec succès", "success");
                        resolve();
                    } else {
                        this.displayMessage("Erreur lors de l'envoi du message", "danger");
                        reject();
                    }
                    this.isLoading = false;
                };
                request.onerror = () => {
                    this.isLoading = false;
                    reject();
                };
                request.send();
            });
        },
        async getSms() {
            var url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/getSms?phoneNumber=33"  + this.invoice.phoneNumber.substring(1) + "&uidInvoice=" + this.invoice.uid;
            var request = new XMLHttpRequest();

            return new Promise((resolve, reject) => {
                request.open("GET", url, true);
                request.onload = () => {
                    if (request.status >= 200 && request.status < 400) {
                        this.messages = JSON.parse(request.responseText);
                        this.messages = this.messages.filter(message => message.status === MessageStatus.DELIVERED || message.status === MessageStatus.WAITING);
                        resolve();
                    } else {
                        reject();
                    }
                };
                request.onerror = () => {
                    reject();
                };
                request.send();
            });
        },
        async getSmsExpert() {
            var url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/getSms?phoneNumber=33"  +  this.getExpertPhoneNumber().substring(1) + "&uidInvoice=" + this.invoice.uid;
            var request = new XMLHttpRequest();

            return new Promise((resolve, reject) => {
                request.open("GET", url, true);
                request.onload = () => {
                    if (request.status >= 200 && request.status < 400) {
                        this.messagesExpert = JSON.parse(request.responseText);
                        this.messagesExpert = this.messagesExpert.filter(message => message.status === MessageStatus.DELIVERED || message.status === MessageStatus.WAITING);
                        resolve();
                    } else {
                        reject();
                    }
                };
                request.onerror = () => {
                    reject();
                };
                request.send();
            });
        },
        async deleteSms(id) {
            this.isLoading = true;
            var url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/deleteSms?id=" + id+"&uidInvoice=" + this.invoice.uid;
            var request = new XMLHttpRequest();

            return new Promise((resolve, reject) => {
                request.open("GET", url, true);
                request.onload = () => {
                    if (200 === request.status) {
                        this.messages = this.messages.filter(message => message.campaign_id !== id);
                        this.messagesExpert = this.messagesExpert.filter(message => message.campaign_id !== id);
                        this.closeModal('modal-see-sms');
                        this.displayMessage("Message supprimé avec succès", "success");
                        resolve();
                    } else {
                        this.displayMessage("Erreur lors de la suppression du message", "danger");
                        reject();
                    }
                    this.isLoading = false;
                };
                request.onerror = () => {
                    this.isLoading = false;
                    reject();
                };
                request.send();
            });
        },
        formatDate(date, hour = false) {
            return moment(date).format(`DD/MM/YYYY${hour ? ' à HH:mm' : ''}`);
        },
        updateSmsMessage() {
            this.newMessage.message = this.smsTemplate.find(template => template.uid === this.selectedTemplate).message;
            this.newMessage.message = this.newMessage.message.replace(/{{.*?}}/g, (match) => {
                const field = match.replace(/{{|}}/g, '');
                const value = field.split('.')[1];
                switch (field.split('.')[0]) {
                    case "client":
                        switch (value) {
                            case "lastName":
                                return this.invoice.lastName + " ";
                            case "firstName":
                                return this.invoice.firstName + " ";
                            case "phoneNumber":
                                return this.invoice.phoneNumber + " ";
                            case "email":
                                return this.invoice.email + " ";
                            case "address":
                                return this.invoice.address.address + " " + this.invoice.address.city + " " + this.invoice.address.zipCode + " ";
                        }
                        break;
                    case "expert":
                        switch (value && this.expert) {
                            case "lastName":
                                return this.experts.find(expert => expert.uid === this.expert).lastName + " ";
                            case "firstName":
                                return this.experts.find(expert => expert.uid === this.expert).firstName + " ";
                            case "phoneNumber":
                                return this.experts.find(expert => expert.uid === this.expert).phoneNumber + " ";
                            case "email":
                                return this.experts.find(expert => expert.uid === this.expert).email + " ";
                            case "postalCode":
                                return this.experts.find(expert => expert.uid === this.expert).postalCode + " ";
                        }
                        break;
                    case "facture":
                        switch (value) {
                            case "amount":
                                return this.invoice.amount + " ";
                            case "date":
                                return this.invoice.date + " ";
                            case "hours":
                                return this.invoice.hours + " ";
                            case "invoiceID":
                               return this.invoice.invoiceID + " ";
                            case "quotationID":
                               return this.invoice.quotationID + " ";
                            case "remuneration":
                                return this.invoice.remuneration + " ";
                        }
                        break;
                    default:
                        return match;
                }
            });
        },
        userChange() {
            this.filtredTemplates = this.templates.filter(document => {
                return document.type === (this.typeUser === 'Expert' ? 1 : 2);
            });
        },
        async generatePDF() {
            this.isPdfLoading = true;
           // const url = "http://127.0.0.1:5001/checkmyhouse-dev/us-central1/generateModifiedPdf";
            const url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/generateModifiedPdf";
            const fields = this.filtredTemplates[this.curentTemplate].fields.filter(field => field.name !== "signing");
            const body = {
                path: this.filtredTemplates[this.curentTemplate].path,
                fields: fields,
                uid: this.invoice.uid,
                templateId: this.filtredTemplates[this.curentTemplate].uid,
            };

            return new Promise((resolve, reject) => {
                const request = new XMLHttpRequest();
                request.open("POST", url, true);
                request.setRequestHeader("Content-Type", "application/json");
                request.responseType = "json";
                let pdfUrl = "";

                request.onload = () => {
                    if (request.status === 200) {
                        const response = request.response;

                        if (response && response.buffer && response.uid) {
                            const binaryString = atob(response.buffer);
                            const pdfBytes = new Uint8Array(binaryString.length);
                            for (let i = 0; i < binaryString.length; i++) {
                                pdfBytes[i] = binaryString.charCodeAt(i);
                            }

                            const blob = new Blob([pdfBytes], { type: "application/pdf" });
                            pdfUrl = window.URL.createObjectURL(blob);

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl + "#toolbar=0";
                            iframe.style.width = "100%";
                            iframe.style.height = "100%";
                            iframe.style.border = "none";
                            this.$refs.pdfContainer.innerHTML = '';
                            this.$refs.pdfContainer.appendChild(iframe);

                            setTimeout(() => {
                                window.URL.revokeObjectURL(pdfUrl);
                            }, 10000);
                            firebase.storage().ref().child(`documents/${this.invoice.uid}/${response.uid}.pdf`).getDownloadURL()
                                .then((url) => {
                                    this.documents.push({
                                        url: url,
                                        name: this.filtredTemplates[this.curentTemplate].name,
                                        createdAt: new Date(),
                                        status: "Document à signer",
                                        metadataStatus: DocumentStatus.TO_SIGN,
                                        uid: response.uid,
                                    });
                                    this.invoice.documents.push({
                                        uid: response.uid,
                                        title: this.filtredTemplates[this.curentTemplate].name,
                                        status: DocumentStatus.TO_SIGN,
                                        templateId: this.filtredTemplates[this.curentTemplate].uid
                                    });
                                })
                                .catch((error) => {
                                    console.error("Error getting document URL: ", error);
                                    this.isPdfLoading = false;
                                });
                            this.isPdfLoading = false;
                            resolve();
                        } else {
                            this.isPdfLoading = false;
                            reject(new Error("La réponse ne contient pas les données attendues."));
                        }
                    } else {
                        this.isPdfLoading = false;
                        reject(new Error(`Échec de la requête. Statut: ${request.status}`));
                    }
                };

                request.onerror = () => {
                    this.isPdfLoading = false;
                    reject(new Error("Erreur réseau lors de la requête."));
                };

                request.send(JSON.stringify(body));
            });
        },
        async downloadPDF(url) {
            if(!url || url instanceof PointerEvent) {
                url = this.documents[this.documents.length - 1].url;
            }
            try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = downloadUrl;
                    a.download = "document.pdf";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(downloadUrl);
                } catch (error) {
                    console.error("Erreur lors du téléchargement du fichier PDF :", error);
                }
            },

        getInfoDocument(uid) {
            if(uid.includes(".pdf")) uid = uid.replace(/.pdf/g, '');
            let name_file = this.invoice.documents.find(doc => doc.uid === uid).title;
            let status, metadataStatus;
            status = metadataStatus = this.invoice.documents.find(doc => doc.uid === uid).status;
            switch (status) {
                case DocumentStatus.WAITING:
                    status = "Document en attente";
                    break;
                case DocumentStatus.SIGNED:
                    status = "Document signé";
                    break;
                case DocumentStatus.TO_SIGN:
                    status = "Document à signer";
                    break;
            }
            return {uid: uid, nameFile: name_file, status: status, metadataStatus: metadataStatus, templateId: this.invoice.documents.find(doc => doc.uid === uid).templateId, SRid: this.invoice.documents.find(doc => doc.uid === uid).SRid,
                yousignId: this.invoice.documents.find(doc => doc.uid === uid).yousignId};
        },
        sendDocumentToYousign(i) {
            this.isLoading = true;
            if(this.documents[i].templateId === undefined) {
                Object.assign(this.documents[i], this.getInfoDocument(this.documents[i].uid));
            }
          this.documents[i].metadataStatus = DocumentStatus.WAITING;
          this.documents[i].status = "Document en attente";
          let signPosition = this.templates.find(template => template.uid === this.documents[i].templateId).fields.find(field => field.name === "signing");
          let url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/sendPdfToYousign";
          let body = {
              user: {
                    email: this.invoice.email,
                    lastname: this.invoice.firstName,
                    firstname: this.invoice.lastName
              },
              file: {
                    name: this.documents[i].name,
                    path: this.invoice.uid + "/" + this.documents[i].uid + ".pdf",
                    position : {
                        page: signPosition.page,
                        x: signPosition.x,
                        y: signPosition.y
                    }
              }
          }
            return new Promise((resolve, reject) => {
                const request = new XMLHttpRequest();
                request.open("POST", url, true);
                request.setRequestHeader("Content-Type", "application/json");
                request.onload = () => {
                    if (request.status === 200) {
                        this.documents[i].SRid = JSON.parse(request.responseText).SRid;
                        this.isLoading = false;
                        this.displayMessage("Document envoyé avec succès", "success");
                        resolve();
                    } else {
                        this.isLoading = false;
                        this.displayMessage("Erreur lors de l'envoi du document", "danger");
                        reject(new Error(`Échec de la requête. Statut: ${request.status}`));
                    }
                };
                request.onerror = () => {
                    this.isLoading = false;
                    this.displayMessage("Erreur réseau lors de la requête.", "danger");
                    reject(new Error("Erreur réseau lors de la requête."));
                };
                request.send(JSON.stringify(body));
            });

        },
        removeDocumentFromYousign(i) {
            this.isLoading = true;
            const SRid = this.documents[i].SRid;
            let url = process.env.VUE_APP_ROOT_FIREBASE_PATH + ".cloudfunctions.net/deleteDocumentYousign?SRid=" + SRid;
            //let url =  "http://127.0.0.1:5001/checkmyhouse-dev/us-central1/deleteDocumentYousign?SRid=" + SRid;
            return new Promise((resolve, reject) => {
                const request = new XMLHttpRequest();
                request.open("GET", url, true);
                request.onload = () => {
                    if (request.status === 204) {
                        this.isLoading = false;
                       // this.displayMessage("Document supprimé avec succès", "success");
                        this.deleteDocument(i);
                        resolve();
                    } else {
                        this.isLoading = false;
                        this.displayMessage("Erreur lors de la suppression du document", "danger");
                        reject(new Error(`Échec de la requête. Statut: ${request.status}`));
                    }
                };
                request.onerror = () => {
                    this.isLoading = false;
                    this.displayMessage("Erreur réseau lors de la requête.", "danger");
                    reject(new Error("Erreur réseau lors de la requête."));
                };
                request.send();
            });
        },
        consult(url) {
            window.open(url, '_blank');
        },
        deleteDocument(i) {
            this.isLoading = true;
            const documentUid = this.documents[i].uid;
            firebase.storage().ref().child(`documents/${this.invoice.uid}/${documentUid}.pdf`).delete()
                .then(() => {
                    firebase.firestore().collection("Invoices").doc(this.invoice.uid).get()
                        .then((doc) => {
                            if (doc.exists) {
                                const invoice = doc.data();
                                invoice.documents = invoice.documents.filter(doc => doc.uid !== documentUid);
                                firebase.firestore().collection("Invoices").doc(this.invoice.uid).update({
                                    documents: invoice.documents
                                }).then(() => {
                                    this.isLoading = false;
                                    this.documents.splice(i, 1);
                                    this.displayMessage("Document supprimé avec succès", "success");
                                }).catch((error) => {
                                    this.isLoading = false;
                                    this.displayMessage("Erreur lors de la suppression du document dans Firestore", "danger");
                                    console.error("Erreur Firestore: ", error);
                                });
                            }
                        }).catch((error) => {
                        this.isLoading = false;
                        this.displayMessage("Erreur lors de la récupération de l'objet invoice", "danger");
                        console.error("Erreur Firestore: ", error);
                    });
                }).catch((error) => {
                this.isLoading = false;
                this.displayMessage("Erreur lors de la suppression du document dans le stockage Firebase", "danger");
                console.error("Erreur stockage Firebase: ", error);
            });
        },
        initializeFields() {
            if (this.filtredTemplates[this.curentTemplate] === undefined) return;
            this.filtredTemplates[this.curentTemplate].fields.forEach(field => {
                if (undefined !== field.bidding) {
                    field.value = '';
                    const bidding = field.bidding.split(",");
                    bidding.forEach(b => {
                        const [key, value] = b.split(".");
                        switch (key.trim()) {
                            case "client":
                                switch (value) {
                                    case "lastName":
                                        field.value += this.invoice.lastName + " ";
                                        break;
                                    case "firstName":
                                        field.value += this.invoice.firstName + " ";
                                        break;
                                    case "phoneNumber":
                                        field.value += this.invoice.phoneNumber + " ";
                                        break;
                                    case "email":
                                        field.value += this.invoice.email + " ";
                                        break;
                                    case "address":
                                        field.value += this.invoice.address.address + " " + this.invoice.address.city + " " + this.invoice.address.zipCode + " ";
                                        break;

                                }
                                break;
                            case "expert":
                                if (this.expert)
                                    switch (value) {
                                        case "lastName":
                                            field.value += this.experts.find(expert => expert.uid === this.expert).lastName + " ";
                                            break;
                                        case "firstName":
                                            field.value += this.experts.find(expert => expert.uid === this.expert).firstName + " ";
                                            break;
                                        case "phoneNumber":
                                            field.value += this.experts.find(expert => expert.uid === this.expert).phoneNumber + " ";
                                            break;
                                        case "email":
                                            field.value += this.experts.find(expert => expert.uid === this.expert).email + " ";
                                            break;
                                        case "postalCode":
                                            field.value += this.experts.find(expert => expert.uid === this.expert).postalCode + " ";
                                            break;
                                        case "remuneration":
                                            field.value += this.invoice.remuneration + " ";
                                            break;
                                    }
                                break;
                            case "facture":
                                switch (value) {
                                    case "amount":
                                        field.value += this.invoice.amount + " ";
                                        break;
                                    case "date":
                                        field.value += this.invoice.date + " ";
                                        break;
                                    case "hours":
                                        field.value += this.invoice.hours + " ";
                                        break;
                                    case "invoiceID":
                                        field.value += this.invoice.invoiceID + " ";
                                        break;
                                    case "quotationID":
                                        field.value += this.invoice.quotationID + " ";
                                        break;
                                    case "remuneration":
                                        field.value += this.invoice.remuneration + " ";
                                        break;
                                    case "typeRemuneration":
                                        field.value += this.paymentTypes[this.invoice.typeRemuneration] + " ";
                                        break;
                                }
                                break;
                        }
                    });
                }
            });
        },
        getExpertPhoneNumber() {
            if(!this.expert) return '';
            return this.experts.find(expert => expert.uid === this.expert).phoneNumber;
        },
        onSmsModalShow() {
            this.selectedTemplate = '';
            this.newMessage.message = '';
            this.filteredTemplatesSMS = this.smsTemplate.filter(document => {
                return document.type === (this.smsRecipient === 1 ? 1 : 2);
            })
            this.newMessage.date = null;
            this.newMessage.time = null;
        },
        async updateEmail() {
            if (!this.invoice.email || this.invoice.email === '') return;
            try {
                await firebase.firestore().collection("Invoices").doc(this.invoice.uid).update({ email: this.invoice.email });
                this.displayMessage("Email mis à jour avec succès", "success");
            } catch (error) {
                this.displayMessage("Erreur lors de la mise à jour de l'email", "danger");
            }
        },
        async updatePhoneNumber() {
            if (!this.invoice.phoneNumber || this.invoice.phoneNumber === '') return;
            try {
                await firebase.firestore().collection("Invoices").doc(this.invoice.uid).update({ phoneNumber: this.invoice.phoneNumber });
                this.displayMessage("Téléphone mis à jour avec succès", "success");
            } catch (error) {
                this.displayMessage("Erreur lors de la mise à jour du téléphone", "danger");
            }
        },
    },
    watch: {
        curentTemplate: {
            immediate: true,
            handler() {
                this.initializeFields();
            }
        },
        expert: async function(newExpertUID) {
            if (newExpertUID && !this.isInitialLoad) {
                try {
                    await firebase.firestore().collection("Invoices").doc(this.invoice.uid).update({
                        expertUID: newExpertUID
                    });
                    this.invoice.expertUID = newExpertUID;
                    this.displayMessage("Expert mis à jour avec succès", "success");
                } catch (error) {
                    this.displayMessage("Erreur lors de la mise à jour de l'expert", "danger");
                }
            }
        },
        'invoice.remuneration': {
            handler: async function(newRemuneration) {
                if (newRemuneration && !this.isInitialLoad) {
                    /* cancel the previous timeout if it exists */
                    if (this.updateTimeout) {
                        clearTimeout(this.updateTimeout);
                    }
                    /* set a new timeout to update the remuneration */
                    this.updateTimeout = setTimeout(async () => {
                        try {
                            await firebase.firestore()
                                .collection("Invoices")
                                .doc(this.invoice.uid)
                                .update({ remuneration: newRemuneration });

                            this.displayMessage("Rémunération mise à jour avec succès", "success");
                        } catch (error) {
                            this.displayMessage("Erreur lors de la mise à jour de la rémunération", "danger");
                        }
                    }, 3000);
                }
            }
        },
        'invoice.typeRemuneration': {
            handler: async function (typeRemuneration) {
                if (typeRemuneration && !this.isInitialLoad) {
                    try {
                        await firebase.firestore()
                            .collection("Invoices")
                            .doc(this.invoice.uid)
                            .update({ typeRemuneration: typeRemuneration });

                        this.displayMessage("Type de rémunération mis à jour avec succès", "success");
                    } catch (error) {
                        this.displayMessage("Erreur lors de la mise à jour du type de rémunération", "danger");
                    }
                }
            }
        },
        'invoice.date': {
            handler: async function (date) {
                if (date && !this.isInitialLoad) {
                    try {
                        await firebase.firestore()
                            .collection("Invoices")
                            .doc(this.invoice.uid)
                            .update({ date: date });

                        this.displayMessage("Date mise à jour avec succès", "success");
                    } catch (error) {
                        this.displayMessage("Erreur lors de la mise à jour de la date de la facture", "danger");
                    }
                }
            }
        },
        'invoice.hours': {
            handler: async function (hours) {
                if (hours && !this.isInitialLoad) {
                    try {
                        await firebase.firestore()
                            .collection("Invoices")
                            .doc(this.invoice.uid)
                            .update({ hours: hours });

                        this.displayMessage("Heures mises à jour avec succès", "success");
                    } catch (error) {
                        this.displayMessage("Erreur lors de la mise à jour des heures", "danger");
                    }
                }
            }
        },
        smsRecipient: async function() {
            this.selectedTemplate = '';
            this.newMessage.message = '';
            this.filteredTemplatesSMS = this.smsTemplate.filter(document => {
                return document.type === (this.smsRecipient === 1 ? 1 : 2);
            })
            this.newMessage.date = null;
            this.newMessage.time = null;
        }
    },
}
</script>

<style scoped>
.right-aligned > div {
    display: flex;
    justify-content: space-between;
    padding-left: 120px;
    margin-bottom: 30px;
}

.uk-text-right {
    padding-right: 150px;
}

hr.uk-margin-remove-top {
    margin-top: -25px !important;
}

.invoiceDetails > div {
    margin-bottom: 20px;
}

.margin_bottom_element {
    margin-bottom: 20px;
}

.uk-margin-left {
    margin-left: 20px;
}

.margin_bottom_small {
    margin-bottom: 10px;
}

.margin_bottom_large {
    margin-bottom: 60px;
}

.uk-margin-right {
    margin-right: auto;
}
.label-tag-sent {
    display: inline-flex;
    align-items: center;
    background-color: #50C124;
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin: 5px;
}
.label-tag {
    display: inline-flex;
    align-items: center;
    background-color: #BFD9E1;
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin: 5px;
}
.label-tag .uk-icon {
    margin-right: 8px;
}
.red-badge {
    background-color: #ad241d;
    color: white;
}
.rounded-btn {
    border-radius: 20px;
}
.rounded-modal {
    border-radius: 10px;
}
.uk-form-custom select {
    background-color: white;
}
.uk-form-custom button {
    background-color: white;
    color: #959191;
    border: 1px solid #dcdada;
}
button:disabled {
    background-color: #ccc;
    color: #666;
    border-color: #ccc;
    cursor: not-allowed;
}
button:disabled:hover {
    background-color: #ccc;
    border-color: #ccc;
    color: #666;
}
 .spinner-overlay {
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background: rgba(255, 255, 255, 0.8);
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 9999;
 }

.spinner {
    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.input-large {
  min-width: 500px;
  max-width: 100%;
}
</style>